import React, { useContext, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  GridItem,
  Img,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Switch,
  Text,
} from '@chakra-ui/react';
import right from 'assets/img/games/right.png';
import left from 'assets/img/games/left.png';
import parch from 'assets/img/games/parch.png';
import on from 'assets/img/games/on.png';
import off from 'assets/img/games/off.png';
import TopMenu from 'assets/img/games/top-menu.png';
import Overview from 'assets/img/games/game-overview.png';
import Setting from 'assets/img/games/settings.png';
import SettingPad from 'assets/img/games/setting-pad.png';
import SliderPointer from 'assets/img/games/slider-pointer.png';
import Close from 'assets/img/games/close.png';
import { ScoreContext, ProfileType } from '../GamePreview';
import { motion } from 'framer-motion';
import { ProfileContext } from '../EntirePreview';
interface ModelPopupProps {
  data?: any;
  options?: any;
  backGroundImg?: any;
  option?: any;
  profile?: any;
  geTfeedBackoption?: any;
  ModelControl?: any;
  preloadedAssets?: any;
  setModelControl: any;
  getPrevLogDatas: any;
  setCurrentScreenId: any;
  setData: any;
  setType: any;
  gameInfo: any;
  setOptions: any;
  gameInfoquest: any;
  gameinfodata: any;
  isStoryScreen: any;
  isSetStoryScreen: any;
  setPreLogDatas: any;
  setNavigateBlockEmpty: any;
  NavigateBlockEmpty: any;
  profileData: any;
  setQuestState: any;
  setReplayState: any;
  setReplayIsOpen: any;
  replayState?: string;
  QuestBlocklastpaused: () => void;
}

const ModelPopup: React.FC<ModelPopupProps> = ({
  data,
  backGroundImg,
  option,
  options,
  geTfeedBackoption,
  ModelControl,
  preloadedAssets,
  setModelControl,
  getPrevLogDatas,
  setCurrentScreenId,
  setType,
  setData,
  gameInfo,
  setOptions,
  gameInfoquest,
  gameinfodata,
  isStoryScreen,
  isSetStoryScreen,
  setPreLogDatas,
  setNavigateBlockEmpty,
  NavigateBlockEmpty,
  profileData,
  setQuestState,
  setReplayState,
  setReplayIsOpen,
  replayState,
  QuestBlocklastpaused,
}) => {
  const [QuestScreen, SetQuestScreen] = useState<boolean>(false);
  const [QuestSelectionPage, SetQuestSelectionPage] = useState<boolean>(false);
  const [PlayAgain, SetPlayAgain] = useState<boolean>(false);
  const initialProfileObject: ProfileType = {
    score: [],
    // completionScore: [],
    completedLevels: ['1'],
    compQuest: [],
    currentQuest: 1,
    replayScore: [],
    playerGrandTotal: { questScores: {} },
    playerGender: '',
    PlayerName: '',
  };
  const { profile, setProfile } = useContext(ScoreContext);
  const useData = useContext(ProfileContext);
  const NextScreen = () => {
    useData?.setMotionEffect(true);
    setTimeout(() => {
      setQuestState({});
      setPreLogDatas((prev: any) => ({
        ...prev,
        nevigatedSeq: [],
        screenIdSeq: [],
        lastActiveBlockSeq: '',
        lastModifiedBlockSeq: null,
        lastBlockModifiedDate: null,
        selectedOptions: '',
        previewScore: initialProfileObject,
        previewProfile: { ...getPrevLogDatas.previewProfile, score: [] },
        questState: {},
      }));
      setProfile(initialProfileObject);
      setModelControl(false);
      setReplayState('');
      setReplayIsOpen(false);
      setCurrentScreenId(1);
    }, 300);
  };
  const continueScreen = () => {
    useData?.setMotionEffect(true);
    setTimeout(() => {
      if (getPrevLogDatas.screenIdSeq.length > 0) {
        const screenlast = getPrevLogDatas.screenIdSeq;
        const getLastScreenId = screenlast[0];
        if (getLastScreenId === 2) {
          setPreLogDatas(getPrevLogDatas);
          setReplayState('Prompt');
          setModelControl(false);
          setReplayIsOpen(true);
          return false;
        } else {
          setPreLogDatas(getPrevLogDatas);
          setCurrentScreenId(getLastScreenId);
          setModelControl(false);
          return false;
        }
      }
    }, 300);
  };

  const HandleBlockScreen = () => {
    setNavigateBlockEmpty(false);
    return false;
  };

  return (
    <>
      <Box id="container" className="Play-station">
        <Box className="top-menu-home-section">
          <Box className="Setting-box">
            <motion.div
              initial={{ scale: 0.5 }}
              animate={{ scale: 1 }}
              transition={{
                type: 'spring',
                stiffness: 300,
                damping: 20,
              }}
              style={{
                width: '100%',
                height: '100%',
                // backgroundColor: 'coral',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Img src={preloadedAssets?.Replay} className="setting-pad" />
              <Box className="replay-vertex">
                <Box
                  w={'100%'}
                  h={'100%'}
                  display={'flex'}
                  flexDirection={'column'}
                  justifyContent={'space-between'}
                >
                  <Box className="replay_game_text">
                    {NavigateBlockEmpty === true
                      ? 'No blocks available. Click "Okay" to redirecting to the initial block'
                      : replayState === 'Prompt'
                      ? 'Do you want to continue from the screen where you last paused ?'
                      : 'Do you want to continue from the screen where you last paused?'}
                  </Box>

                  <Box
                    display={'flex'}
                    justifyContent={
                      NavigateBlockEmpty === true ? 'center' : 'space-between'
                    }
                    w={'100%'}
                  >
                    {NavigateBlockEmpty === true ? (
                      <Button background={'transparent !important'}>
                        <Img
                          src={preloadedAssets?.OkayBtn}
                          className="replay_game_btn"
                          onClick={HandleBlockScreen}
                        />
                      </Button>
                    ) : replayState === 'Prompt' ? (
                      <>
                        <Button background={'transparent !important'}>
                          <Img
                            src={preloadedAssets?.No}
                            onClick={NextScreen}
                            className="replay_game_btn_cancel"
                          />
                        </Button>
                        <Button background={'transparent !important'}>
                          <Img
                            src={preloadedAssets?.Yes}
                            className="replay_game_btn"
                            onClick={QuestBlocklastpaused}
                          />
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button background={'transparent !important'}>
                          <Img
                            src={preloadedAssets?.No}
                            onClick={NextScreen}
                            className="replay_game_btn_cancel"
                          />
                        </Button>
                        <Button background={'transparent !important'}>
                          <Img
                            src={preloadedAssets?.Yes}
                            className="replay_game_btn"
                            onClick={continueScreen}
                          />
                        </Button>
                      </>
                    )}
                  </Box>
                </Box>
              </Box>
            </motion.div>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ModelPopup;
